module.exports = __webpack_public_path__ + "static/media/promotedBy.ebd4dc93.svg";